import { Box } from "@material-ui/core";
import React from "react";
import { useSelector } from "react-redux";
import { TargetGroupSvg } from "../../../../../assets/icons/custom-svg-components/CompanySvgCollection";
import {
  ParticipationType,
  TargetGroupIdData,
} from "../../../../../models/targetGroupData";
import { AppState } from "../../../../../redux";
import { mapToTargetGroupTranslationKey } from "../../../../../models/enums/eventType.enum";
import { getDynamicTranslation } from "../../../localization/localizationUtils";
import { Utils } from "../../../../../services/utils";

interface ITargetGroupListProps {
  targetGroups: TargetGroupIdData;
}

const TargetGroupList: React.FunctionComponent<ITargetGroupListProps> = (props) => {
  const targetGroups = useSelector((state: AppState) => state.targetGroups.targetGroups);

  function mapParticipationTypesToValidItemsString(
    participationTypeIds: string[],
    addComma?: false
  ): string {
    const participationTypeItems: ParticipationType[] = participationTypeIds.map(
      (id) => {
        return {
          id,
          document_type: Utils.mapTargetGroupIdToString(
            id,
            targetGroups.participation_types
          ),
          label: "",
          is_default: false,
        };
      }
    );
    const validParticipationTypeItems: ParticipationType[] =
      participationTypeItems.filter((item) => item.document_type.length > 0);

    let validParticipationTypeItemsString = validParticipationTypeItems
      .map((item) => mapToTargetGroupTranslationKey(item.document_type))
      .map((translationKey) => getDynamicTranslation(translationKey, "common"))
      .join(", ");

    if (addComma) validParticipationTypeItemsString += ", ";
    return validParticipationTypeItemsString;
  }

  return (
    <Box component="span" display="flex" alignItems="center">
      {props?.targetGroups?.participation_types &&
      props?.targetGroups?.participation_types.length > 0 ? (
        <>
          <TargetGroupSvg />
          {mapParticipationTypesToValidItemsString(
            props?.targetGroups?.participation_types
          )}
        </>
      ) : null}
    </Box>
  );
};

export default TargetGroupList;
